import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { DEBUG_STATE } from "../../constants/constants.js"
import ReactTooltip from "react-tooltip";
import { PopoverPicker } from "../common/PopoverPicker";


function DocTypeEdit(props) {
  const { authentication, org, org_id, closeModal, editDocType, docType, } = props;

  const doc_types = org?.doc_types;
  var orgTypes;

  const cancelicon = require("../../images/status-red.png").default;
  const saveicon = require("../../images/status-green.png").default;


  const [docTypeRequest, setDocTypeRequest] = useState(JSON.parse(JSON.stringify(docType)));
  const [oldName, setOldName] = useState(JSON.parse(JSON.stringify(docType)).doc_type);
  const [color, setColor] = useState(JSON.parse(JSON.stringify(docType)).color);
  const debug = DEBUG_STATE;

  const setName = (e) => {
    const { value } = e.target;
    docTypeRequest["doc_type_name"] = value;
    //if (debug) console.log(docTypeRequest);
  };

  const setCode = (e) => {
    const { value } = e.target;
    docTypeRequest["labelCode"] = value;
    //if (debug) console.log(docTypeRequest);
  };

  const changeColor = (color) => {
    if (color.charAt(0) === '#') {
      setColor(color.substring(1));
      docTypeRequest["color"] = color.substring(1);
    } else {
      docTypeRequest["color"] = color;
    }
  }



  const handleSubmit = (event) => {
    var col = color || docType.color;

    if (col.charAt(0) === '#') {
      setColor(col.substring(1));
      docTypeRequest["color"] = col.substring(1);
    } else {
      docTypeRequest["color"] = col;
    }

    docTypeRequest["org_id"] = org_id;
    docTypeRequest["old_name"] = oldName;
    if (debug) console.log(docType);
    if (debug) console.log(docTypeRequest);
    editDocType(docTypeRequest);
    closeModal();

  };

  return (
    <div>
      <h3>
        edit document type
        &nbsp;&nbsp;&nbsp;
        <span className="h3SubSpan">(editing)</span>
        &nbsp;&nbsp;&nbsp;

        <div className="editJacketNameIcon" onClick={closeModal} data-tip data-for="cancel">
          <img src={cancelicon} className="cancelImage" width="20px" alt="cancel" />
        </div>
        &nbsp;&nbsp;&nbsp;
        <ReactTooltip id="cancel" place="bottom" effect="solid" data-type="info" delayShow={200}>
          cancel
        </ReactTooltip>

        <div className="editJacketNameIcon" onClick="" data-tip data-for="save" >
          <img src={saveicon} className="saveImage" width="20px" alt="save" onClick={handleSubmit} />
        </div>
        <ReactTooltip id="save" place="bottom" effect="solid" data-type="info" delayShow={200}>
          save
        </ReactTooltip>
      </h3>

      <table className="modalFormTable">
        <colgroup>
          <col span="1" style={{ width: "15%" }} />
          <col span="1" style={{ width: "85%" }} />
        </colgroup>
        <tbody>
          <tr>
            <td className="modalFormLabel" width="20%"><span className="requiredAsterisk">*</span>Name</td>
            <td className="modalFormInfo">
              <input
                style={{ width: "100%" }}
                id="name"
                name="name"
                type="text"
                maxLength="128"
                defaultValue={docType?.doc_type}
                onChange={setName}
              />
            </td>
          </tr>
          <tr>
            <td className="modalFormLabel"><span className="requiredAsterisk">*</span>Code</td>
            <td className="modalFormInfo">
              <input
                style={{ width: "100%" }}
                id="code"
                name="code"
                type="text"
                maxLength="2"
                defaultValue={docType?.labelCode}
                onChange={setCode}
              />
            </td>
          </tr>
          <tr>
            <td className="modalFormLabel"><span className="requiredAsterisk">*</span>Color</td>
            <td className="modalFormInfo">
              <PopoverPicker color={"#" + color} onChange={changeColor} />
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  editDocType: orgActions.editDocType
};

const connectedDocTypeEdit = connect(mapStateToProps, actionCreators)(DocTypeEdit);
export { connectedDocTypeEdit as DocTypeEdit };
